export default function ($sbExternalService) {
    "ngInject";

    return {
        getAll,
    };

    /**
     * Returns all tags for the currently active project.
     *
     * @returns {Promise<Array<{id: string, name: string, color: string}>>}
     */
    function getAll() {
        return $sbExternalService.tagsService().getCollection();
    }
}
